import React from "react";
import { Link } from "react-router-dom";
import { articles } from "../articlesData";

const featured = articles.filter((a) => a.section === "blog").slice(0, 3);

export default function NewsStories() {
  return (
    <section className="mu-section" id="blog">
      <div className="container">
        <div className="section-head-row">
          <div>
            <div className="mu-eyebrow">The Blog</div>
            <h2 className="section-title">Latest News &amp; Stories</h2>
            <p className="section-sub">
              Stay updated with breaking music news, exclusive interviews, entertainment
              trends, industry insights, and cultural stories.
            </p>
          </div>
          <Link to="/blog" className="btn-mu-outline">Read More Stories &rarr;</Link>
        </div>

        <div className="row g-4">
          {featured.map((n) => (
            <div className="col-md-4" key={n.slug}>
              <Link to={`/stories/${n.slug}`} className="track-card-link">
                <div className="news-card">
                  <div className="news-thumb">
                    <img src={n.heroImage} alt={n.title} />
                  </div>
                  <div className="news-body">
                    <span className="news-tag">{n.tag}</span>
                    <div className="news-title">{n.title}</div>
                    <p className="news-excerpt">{n.excerpt}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
